import React from 'react';
import { useDroppable } from '@dnd-kit/core';

interface IProps {
  children: any;
  id: string;
}

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
const Droppable = (props: IProps) => {
  const { children, id } = props;
  const { isOver, setNodeRef } = useDroppable({
    id,
  });
  const style = {
    color: isOver ? 'green' : undefined,
  };

  return (
    <div ref={setNodeRef} style={style}>
      {children}
    </div>
  );
};

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default Droppable;
